import {useMemo} from 'react';

import {hasValue} from '@famly/stat_ts-utils_has-value';

import {useSubscribeFileTagging} from '../use-subscribe-file-tagging';
import {useGetFiles} from './use-get-files';

export const useSelectedFile = () => {
    const {taggedFiles, selectedTaggedFileIndex} = useSubscribeFileTagging(state => state);

    const files = useGetFiles();

    const selectedFile = useMemo(() => {
        if (!files?.current || taggedFiles.length === 0 || !hasValue(selectedTaggedFileIndex)) {
            return undefined;
        }

        return files.current.find(file => file.id === taggedFiles[selectedTaggedFileIndex].fileId);
    }, [files, taggedFiles, selectedTaggedFileIndex]);

    return selectedFile;
};
